export type ColumnKey = string;

export interface ReorderOptions {
  // keys that are currently visible, in visible order
  visible: ColumnKey[];
  // all columns in current stored order (includes hidden)
  fullOrder: ColumnKey[];
  // pinned columns cannot move across their pinned region
  pinnedLeft?: ColumnKey[];
  pinnedRight?: ColumnKey[];
  // hidden columns remain in fullOrder in place
  hidden?: ColumnKey[];
  rtl?: boolean;
}

// Pure reorder utility: returns new fullOrder
export function reorderColumns(opts: ReorderOptions, fromKey: ColumnKey, toKey: ColumnKey): ColumnKey[] {
  const { visible, fullOrder, pinnedLeft = [], pinnedRight = [] } = opts;

  const vis = visible.slice();
  const fromIndex = vis.indexOf(fromKey);
  const toIndex = vis.indexOf(toKey);
  if (fromIndex === -1 || toIndex === -1) return fullOrder;

  // Prevent moving across pinned boundaries
  const isPinnedLeft = (k: string) => pinnedLeft.includes(k);
  const isPinnedRight = (k: string) => pinnedRight.includes(k);
  if ((isPinnedLeft(fromKey) && !isPinnedLeft(toKey)) || (isPinnedRight(fromKey) && !isPinnedRight(toKey))) {
    return fullOrder; // disallow
  }

  // RTL means reverse visual positions for ordering intent
  const src = fromIndex;
  const dst = toIndex;
  const newVis = vis.slice();
  const [moved] = newVis.splice(src, 1);
  newVis.splice(dst, 0, moved);

  // Merge back into full order without changing hidden positions
  const merged = fullOrder.map((k) => (vis.includes(k) ? newVis.shift()! : k));
  return merged;
}
